import { Card } from "@/components/ui/card"
import { cn } from "@/lib/utils"

interface PaymentGatewayCardProps {
	icon: React.ReactNode
	name: string
	variant: "RAZORPAY" | "EASEBUZZ" | "EDVIRON"
	onClick?: () => void
	disabled?: boolean
}

export const PaymentGatewayCard = ({
	icon,
	name,
	variant,
	onClick,
	disabled = false,
}: PaymentGatewayCardProps) => {
	const variantStyles = {
		RAZORPAY: `hover:border-razorpay/30 group-hover:shadow-razorpay/10 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`,
		EASEBUZZ: `hover:border-easebuzz/30 group-hover:shadow-easebuzz/10 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`,
		EDVIRON: `hover:border-edviron/30 group-hover:shadow-edviron/10 ${disabled ? "opacity-50 cursor-not-allowed" : ""}`,
	}

	return (
		<button
			type="button"
			className={cn(
				"w-full text-left",
				disabled ? "cursor-not-allowed" : "cursor-pointer"
			)}
			onClick={disabled ? undefined : onClick}
			aria-disabled={disabled}
		>
			<Card
				className={cn(
					"group relative flex items-center gap-4 overflow-hidden border-2 p-4 transition-all duration-200 w-full",
					"border-border/50 bg-card border",
					"min-h-[80px]",
					variantStyles[variant],
					disabled ? "opacity-50" : "hover:shadow-md"
				)}
			>
			<div className="flex-shrink-0">{icon}</div>
			<div className="flex-1">
				<p className="text-foreground group-hover:text-foreground/90 text-base font-semibold">
					{name}
				</p>
			</div>

			{/* Subtle hover effect overlay */}
			<div className="absolute inset-0 rounded-lg bg-gradient-to-br from-white/[0.02] to-transparent opacity-0 transition-opacity duration-200 group-hover:opacity-100" />
			</Card>
		</button>
	)
}
